import React, { ReactNode } from "react"

interface FooterProps {
  links: ReactNode[]
  socials?: ReactNode[]
}

export const Footer = ({ links, socials }: FooterProps) => (
  <nav className="bg-brand-600 flex justify-center px-5 pt-8 pb-16 md:py-12 md:px-14">
    <div className="max-w-8xl flex w-full flex-col justify-between gap-6 md:flex-row md:items-center">
      <div className="flex basis-5/12 gap-3">
        <span className="text-sm leading-5 text-white antialiased">
          Made with{" "}
          <a
            href="https://www.gorillashops.io/"
            target="_blank"
            rel="noreferrer"
            className="text-sm leading-5 text-white underline antialiased"
          >
            Gorilla Shops
          </a>
        </span>
      </div>
      {socials && (
        <div className="flex basis-2/12 gap-4 md:justify-center">{socials}</div>
      )}
      <div className="flex basis-5/12 flex-col gap-4 md:flex-row md:items-center md:justify-end md:gap-14 md:text-center">
        {links}
      </div>
    </div>
  </nav>
)
